const am4core = await import("@amcharts/amcharts4/core");
const am4charts = await import("@amcharts/amcharts4/charts");

export class LineChartHelper {
    public static AddYValueAxis(chart: any, minValueAxis = null, overrideFill = "#828894", overrideStroke = "#828894", fontSize = 13, strokeWidth = 1, strokeDasharray = "3", strokeOpacity = 1){
        const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.grid.template.strokeWidth = 0;
        valueAxis.renderer.labels.template.fill = am4core.color(overrideFill);
        valueAxis.renderer.labels.template.fontSize = fontSize;
        valueAxis.renderer.line.strokeOpacity = strokeOpacity;
        valueAxis.renderer.line.stroke = am4core.color(overrideStroke);
        valueAxis.renderer.line.strokeWidth = strokeWidth;
        valueAxis.renderer.line.strokeDasharray = strokeDasharray;
        valueAxis.numberFormatter = new am4core.NumberFormatter();
        valueAxis.numberFormatter.numberFormat = '#,###';
        valueAxis.extraMax = 0.02; //adds 2% padding to the top
        valueAxis.extraMin = 0.02; //adds 2% padding to the bottom
        if(minValueAxis != null) {
            valueAxis.min = minValueAxis;
            valueAxis.strictMinMax = true;
        }
        return valueAxis;
    }

    public static AddXCategoryAxis(chart: any, category: string, overrideFill = "#828894", overrideStroke = "#dedede", strokeWidth = 1) {
        const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = category;
        categoryAxis.renderer.labels.template.fill = am4core.color(overrideFill);
        categoryAxis.renderer.line.strokeOpacity = 1;
        categoryAxis.renderer.line.stroke = am4core.color(overrideStroke);
        categoryAxis.renderer.line.strokeWidth = strokeWidth;
        categoryAxis.renderer.minGridDistance = 5;
        return categoryAxis;
    }

    public static AddXValueAxis(chart: any, category: string, overrideFill = "#828894", overrideStroke = "#dedede", strokeWidth = 1){
        const categoryAxis = chart.xAxes.push(new am4charts.ValueAxis());
        categoryAxis.dataFields.value = category;
        categoryAxis.renderer.labels.template.fill = am4core.color(overrideFill);
        categoryAxis.renderer.line.strokeOpacity = 1;
        categoryAxis.renderer.line.stroke = am4core.color(overrideStroke);
        categoryAxis.renderer.line.strokeWidth = strokeWidth;
        categoryAxis.renderer.minGridDistance = 80;
        return categoryAxis;
    }

    public static SetXCategoryAxisAsNumeric(categoryAxis: any) {
        const cloned = categoryAxis.numberFormatter.clone("numberFormatter");
        cloned.bigNumberPrefixes = [];
        cloned.numberFormat = "#";
        categoryAxis.numberFormatter = cloned;
        categoryAxis.renderer.minGridDistance = 80;
    }

    public static AddXDateAxis(chart: any)
    {
        const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        return dateAxis;
    }

    public static AddCategorySeries(chart: any, strokeColor: string, categoryXProperty, valueYProperty, tooltipText, isXNumericValue: boolean = false){
        const series = chart.series.push(new am4charts.LineSeries());
        series.dataFields.valueY = valueYProperty;
        if (isXNumericValue) {
            series.dataFields.valueX = categoryXProperty;
        }
        else {
            series.dataFields.categoryX = categoryXProperty;
        }
        series.fill = am4core.color(strokeColor);
        series.stroke = am4core.color(strokeColor);
        series.tooltipText = tooltipText; //Fix for DEL-7759

        LineChartHelper.setSeriesConfig(series, strokeColor, valueYProperty, tooltipText);

        return series;
    }

    public static AddDateLineSeries(chart: any, strokeColor: string, dateProperty: string, valueYProperty: string, tooltipText: string){
        const series = chart.series.push(new am4charts.LineSeries());
        series.dataFields.valueY = valueYProperty;
        series.dataFields.dateX = dateProperty;
        LineChartHelper.setSeriesConfig(series, strokeColor, valueYProperty, tooltipText);
        return series;
    }

    private static setSeriesConfig(series: any, strokeColor: string, valueYProperty: string, tooltipText: string){
        series.name = valueYProperty;
        series.strokeWidth = 2;
        series.tensionX = 0.7;
        const bullet = series.bullets.push(new am4charts.CircleBullet());
        bullet.fill = strokeColor;
        bullet.stroke = strokeColor;
        bullet.tooltipHTML = tooltipText;
        series.stroke = am4core.color(strokeColor);
    }

    public static AddCategoryLineSeries(chart: any, strokeColor: string, categoryXProperty, valueYProperty, tooltipText, isXNumericValue: boolean = false){
        const series = chart.series.push(new am4charts.LineSeries());
        series.dataFields.valueY = valueYProperty;
        if (isXNumericValue) {
            series.dataFields.valueX = categoryXProperty;
        }
        else {
            series.dataFields.categoryX = categoryXProperty;
        }
        series.fill = am4core.color(strokeColor);
        series.stroke = am4core.color(strokeColor);
        LineChartHelper.setLineSeriesConfig(series, strokeColor, valueYProperty);
        return series;
    }

    private static setLineSeriesConfig(series: any, strokeColor: string, valueYProperty: string){
        series.name = valueYProperty;
        series.strokeWidth = 2;
        series.tensionX = 0.7;
        series.stroke = am4core.color(strokeColor);
    }
}